<template>
  <v-dialog v-model="dialog" scrollable max-width="1100">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm học sinh mới</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" class="pt-10">
          <v-row>
            <v-col cols="4" class="py-0">
              <AutocompleteGrade
                return-object
                v-model="grade"
                label="Khối"
                outlined
                class="required"
                dense
                :rules="[$rules.required]"
                @change="gradeChanged"
              />
            </v-col>
            <v-col cols="4" class="py-0">
              <AutocompleteClass
                v-model="classData"
                label="Lớp"
                outlined
                class="required"
                dense
                :rules="[$rules.required]"
                :filter="gradeId"
                @change="classChanged"
              />
            </v-col>
            <v-col class="py-0" cols="4">
              <AutocompleteStudent
                :syncedValue.sync="student"
                label="Học sinh"
                outlined
                class="required"
                dense
                :rules="[$rules.required]"
                :filter="classId"
                @change="studentChanged"
              />
            </v-col>
          </v-row>
          <v-col cols="12" class="px-0">
            <v-autocomplete
              v-model="bus"
              :items="buses"
              item-value="id"
              item-text="name"
              label="Tuyến xe"
              outlined
              class="required"
              dense
              :rules="[$rules.required]"
            >
            </v-autocomplete
          ></v-col>
          <v-col cols="12" v-if="bus">
            <v-checkbox v-model="amIn" label="Đến trường buổi sáng" hide-details></v-checkbox>
            <BusStopDaysDataTable v-if="amIn" ref="bus-stop-in-am" :busId="bus" :direction="'in'" :periodTime="'AM'" />

            <v-checkbox v-model="amOut" label="Rời trường buổi sáng" hide-details></v-checkbox>
            <BusStopDaysDataTable
              v-if="amOut"
              ref="bus-stop-out-am"
              :busId="bus"
              :direction="'out'"
              :periodTime="'AM'"
            />

            <v-checkbox v-model="pmIn" label="Đến trường buổi chiều" hide-details></v-checkbox>
            <BusStopDaysDataTable v-if="pmIn" ref="bus-stop-in-pm" :busId="bus" :direction="'in'" :periodTime="'PM'" />

            <v-checkbox v-model="pmOut" label="Rời trường buổi chiều" hide-details></v-checkbox>
            <BusStopDaysDataTable
              v-if="pmOut"
              ref="bus-stop-out-pm"
              :busId="bus"
              :direction="'out'"
              :periodTime="'PM'"
            />
          </v-col>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent'
import BusStopDaysDataTable from '@/modules/bus/BusStopDaysDataTable.vue'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteClass,
    AutocompleteStudent,
    BusStopDaysDataTable
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      name: '',
      grade: '',
      classData: '',
      student: null,
      bus: '',
      buses: [],
      type: 'AM-in',
      amIn: false,
      amOut: false,
      pmIn: false,
      pmOut: false
    }
  },
  computed: {
    ...mapState('constant', ['busStatus']),

    gradeId() {
      return { grade: get(this.grade, 'id') }
    },
    classId() {
      return { currentClass: get(this.classData, 'id') }
    },
    disableBusStop() {
      return !this.bus || !this.bus.id || !this.type
    }
  },
  async created() {
    this.buses = await this.fetchBuses()
  },
  methods: {
    ...mapActions('bus', ['fetchBuses']),
    ...mapActions('BusStudents', ['addStudentInBusStops']),

    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },
    studentChanged(student) {
      this.grade = get(student, 'grade')
      this.classData = get(student, 'currentClass')
    },
    classChanged(classData) {
      this.grade = get(classData, 'grade')
      if (get(this.student, 'currentClass.id') !== get(classData, 'id')) this.student = null
    },
    gradeChanged(grade) {
      if (get(this.classData, 'grade.id') !== get(grade, 'id')) this.classData = null
      if (get(this.student, 'grade.id') !== get(grade, 'id')) this.student = null
    },

    async save() {
      let busStop = []
      busStop = this.$refs['bus-stop-in-am'] ? busStop.concat(this.$refs['bus-stop-in-am'].getData()) : busStop
      busStop = this.$refs['bus-stop-out-am'] ? busStop.concat(this.$refs['bus-stop-out-am'].getData()) : busStop
      busStop = this.$refs['bus-stop-in-pm'] ? busStop.concat(this.$refs['bus-stop-in-pm'].getData()) : busStop
      busStop = this.$refs['bus-stop-out-pm'] ? busStop.concat(this.$refs['bus-stop-out-pm'].getData()) : busStop

      if (this.$refs.form.validate()) {
        if (!busStop.length) {
          let mess = 'Điểm dừng không được bỏ trống'
          return this.$alert.error(mess)
        }
        try {
          let params = {
            student: this.student.id,
            busStops: busStop
          }
          await this.addStudentInBusStops(params)
          this.$alert.updateSuccess()
          this.reset()
          this.dialog = false
        } catch (error) {
          this.$alert.updateError(error)
        }
      }
    },
    reset() {
      this.student = null
      this.classData = null
      this.grade = null
      this.bus = null
      this.amIn = false
      this.amOut = false
      this.pmIn = false
      this.pmOut = false
      this.$refs.form.resetValidation()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
